import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { MapPin, Mail, Phone, Clock } from 'lucide-react';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-accent text-accent-foreground mt-auto">
      <div className="container-custom px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About Section with Logo */}
          <div className="space-y-4">
            {/* Logo */}
            <a 
              href="https://prirodanmed.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 hover:opacity-80 transition-opacity mb-4"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_static-website-1/artifacts/v08vnpx2_Logo%20samo%20p%C4%8Delica.jpg" 
                alt="Markovic Farm Logo" 
                className="h-16 w-16 object-contain"
              />
              <span className="text-xl font-semibold text-accent-foreground">
                Prirodan Med
              </span>
            </a>
            <h3 className="text-xl font-semibold">{t('about.title')}</h3>
            <p className="text-accent-foreground/90 text-sm leading-relaxed">
              {t('footer.about')}
            </p>
          </div>

          {/* Center - Decorative Honey Icon (replaces 559KB image) */}
          <div className="flex items-center justify-center">
            <div className="text-center p-6 bg-primary/10 rounded-2xl">
              <div className="text-6xl mb-2">🍯</div>
              <div className="text-2xl">🐝</div>
              <p className="text-primary font-semibold mt-2">Prirodan Med</p>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold mb-4">{t('contact.info.title')}</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5 text-primary" />
                <div>
                  <p className="font-medium">{t('contact.info.address')}</p>
                  <p className="text-accent-foreground/80">
                    Žikiće Jovanovića Španca 14<br />
                    18000 Niš, Serbia
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 flex-shrink-0 text-primary" />
                <a 
                  href="mailto:markovic@prirodanmed.com" 
                  className="hover:text-primary transition-colors"
                >
                  markovic@prirodanmed.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 flex-shrink-0 text-primary" />
                <a 
                  href="tel:+38163637353" 
                  className="hover:text-primary transition-colors"
                >
                  +381 63 63 73 53
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 flex-shrink-0 mt-0.5 text-primary" />
                <div>
                  <p className="font-medium">{t('contact.info.hours')}</p>
                  <p className="text-accent-foreground/80">
                    {t('contact.info.monday')}: {t('contact.info.mondayTime')}<br />
                    {t('contact.info.weekend')}: {t('contact.info.weekendTime')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-accent-foreground/20 pt-8 text-center">
          <p className="text-sm text-accent-foreground/80">
            {t('footer.poweredBy')}{' '}
            <a 
              href="https://www.mitaict.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-primary hover:underline font-medium"
            >
              MITAICT AB
            </a>
          </p>
          <p className="text-xs text-accent-foreground/60 mt-2">
            © {new Date().getFullYear()} Prirodan Med. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}